module.exports = __webpack_public_path__ + "static/2-bfd6b202bd263c1a3ab54780533dd159.png";